<template>
<div class="chapter">
<div class="inner_page">
<p class="img1"><a id="page-v"><img alt="art" src="images/Art_Ptagger1.jpg"/></a></p><a id="page-v">
<p class="ded1"><strong>For:</strong></p>
<p class="ded"><strong>Liam, Bidely, and Bas—the Father, the Mother,</strong></p>
<p class="ded3"><strong>and the Holy Bust!!!</strong></p>
<p class="ded1"><strong>OBEs (Order of the Bloody Entrails) to:</strong></p>
<p class="ded"><strong>Geir, Wiedar, Jon, and all the nocturnal</strong></p>
<p class="ded3"><strong>Norwegian Shan crew</strong></p>
<p class="ded1"><strong>Road Managers:</strong></p>
<p class="ded"><strong>Geraldine Stroud—the ripper skipper!</strong></p>
<p class="ded3"><strong>Mary Byrne—the tipsy first mate!</strong></p>
<p class="ded1"><strong>Editor-in-chief:</strong></p>
<p class="ded3"><strong>Stella Paskins—10 rounds, not out!!</strong></p>
<p class="ded1"><strong>Apocalyptic agents:</strong></p>
<p class="ded3"><strong>the Christopher Little chorus line</strong></p>
<p class="ded1"><strong>And an extra special thank you to all of my demonically delightful Shansters, especially those of you who have kept me company
            on the web through the run of the series. But take heed—if you desert me at this point, heads will roll!!!!</strong></p>
<p class="img"><img alt="art" src="images/Art_Ptagger1.jpg"/></p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// DemonataHellsH_dedi-1.vue?7100310f